import AutoNumericInput from './AutoNumericInput';

export default AutoNumericInput;
